// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__L21sc"};